var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"Error404NotFoundView"}},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('views.errors.error404NotFoundView.title')))])])}
var staticRenderFns = []

export { render, staticRenderFns }